import { useMsal } from "@azure/msal-react";
import { fetchToken } from "../services/fetchTokenService";
import { loginRequest } from "../auth/authConfig";
import SessionValidation from "../context/SessionValidationContext";


export const FetchUserProfileService = () => {

    const { instance, accounts } = useMsal();
    const {setSessionExpired} = SessionValidation()

    const fetchUserProfile = async(username) => {
        try {
            const tokenResponse = await fetchToken(instance, loginRequest, accounts);
            if(tokenResponse && tokenResponse.sessionExpired){
              sessionStorage.clear();
              setSessionExpired(true)
            }
            // console.log("RESPONSE ACCESS TOKEN ", tokenResponse.accessToken);
            // https://graph.microsoft.com/beta/search/query
            const raw = JSON.stringify({
              "requests": [
                {
                  "entityTypes": [
                    "person"
                  ],
                  "query": {
                    "queryString": `${username}`
                  }
                }
              ]
            })
            // `https://graph.microsoft.com/v1.0/me/people/?$search=${username}` ,

            const response = await fetch(
              "https://graph.microsoft.com/v1.0/search/query",
              {
                method: "POST",
                body: raw,
                headers: {
                  "Content-Type": "application/json",
                  // Add other headers if needed
                  Authorization: `Bearer ${tokenResponse.accessToken}`,
                },
              }
            )
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            
            return data
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    };


    return {
        fetchUserProfile
    }
    }
   

    // const fetchPortfolioData = useCallback(
    //   async (apiEndpoint, username) => {
    //     logInfo("fetchPortfolioData", "fetching portfolio data");
    //     try {
    //       const url = apiEndpoint + `/me/people/?$search={username}`;
    //       const data = await fetchWithRetry(url);
    //       logInfo("fetchPortfolioData", "fetched portfolio data successfully");
    //       return data;
    //     } catch (error) {
    //       logError("fetchPortfolioData", "error fetching portfolio data", error);
    //       throw error;
    //     }
    //   },
    //   [fetchWithRetry]
    // );
// }